<template>
  <b-container fluid style="height: calc(100vh - 185px)" class="px-0">
    <b-card id="card-principal" class="mb-0 pb-0" style="height: calc(100% - 50px);">
      <template #header>
        <i class="fas fa-edit"></i>
        <strong>{{$lang.PCI.PDR.PrincipalTitle}}</strong>
      </template>
      <ag-grid-vue style="width: 100%; height: 100%"
                    id="obras-grid"
                    class="ag-theme-alpine"
                    rowSelection="multiple"
                    :suppressRowClickSelection="true"
                    :getLocaleText="localeTextFunc"
                    :gridOptions="obrasDataGridOptions"
                    :columnTypes="columnTypes"
                    :columnDefs="obrasColumnDefs"
                    :defaultColDef="defaultColumnDef"
                    :rowData="obrasRowData"
                    :isRowSelectable="isRowSelectable"
                    @cellDoubleClicked="viewForm"
                    @gridReady="onGridReady">
      </ag-grid-vue>
    </b-card>
    <div id="div-buttons">
      <button type="button" class="btn btn-third btn-sm" v-on:click="enviarEmail()" v-b-tooltip.hover><i class="fa fa-check"></i> Enviar e-mail</button>
    </div>

    <b-modal
      v-model="showForm"
      ref="modal"
      size="xl"
      centered
      :hide-footer="true"
    >
      <template #modal-header>
        <div id="revisionForm" class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{'Formulário de Revisão'}}<span v-if="editFormEnabled">{{' (Em Edição)'}}</span>
          </span>
          <button class="close" @click="onHide">x</button>
        </div>
      </template>
      <div v-if="showForm" class="d-flex flex-column justify-content-start">
        <b-row class="formularioAvaliacaoTitulo">
          <b-col cols="3"><span>Contrato</span></b-col>
          <b-col cols="1" class="pl-0"><span>Obra</span></b-col>
          <b-col cols="2" class="pl-0"><span>ID Site</span></b-col>
          <b-col cols="1" class="pl-0"></b-col>
          <b-col cols="1" class="pl-0"><span>Início</span></b-col>
          <b-col cols="1" class="pl-0"><span>Término</span></b-col>
          <b-col cols="1" class="pl-0"><span>Prazo</span></b-col>
          <b-col cols="1" class="pl-0"><span>Dias Parados</span></b-col>
          <b-col cols="1" class="pl-0"><span>Prazo Real</span></b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="3"><b-input disabled v-model="formCheckList.contrato"></b-input></b-col>
          <b-col cols="1" class="pl-0"><b-input class="p-2" disabled v-model="formCheckList.obra"></b-input></b-col>
          <b-col cols="2" class="pl-0"><b-input class="p-2" disabled v-model="formCheckList.idSite"></b-input></b-col>
          <b-col cols="1" class="pl-0"></b-col>
          <b-col cols="1" class="pl-0"><b-input class="p-2" disabled v-model="formCheckList.inicioObra"></b-input></b-col>
          <b-col cols="1" class="pl-0"><b-input class="p-2" disabled v-model="formCheckList.terminoObra"></b-input></b-col>
          <b-col cols="1" class="pl-0"><b-input class="p-2" type="number" disabled v-model="formCheckList.prazoObra"></b-input></b-col>
          <b-col cols="1" class="pl-0"><b-input class="p-2" type="number" disabled v-model="formCheckList.diasParados"></b-input></b-col>
          <b-col cols="1" class="pl-0"><b-input class="p-2" type="number" disabled v-model="realTerm"></b-input></b-col>
        </b-row>
        <b-row class="formularioAvaliacaoTitulo">
          <b-col cols="2"><span>Tipo</span></b-col>
          <b-col cols="2"><span>Valor</span> </b-col>
          <b-col cols="2"><span>Responsável</span></b-col>
          <b-col cols="1"></b-col>
          <b-col cols="5">
            <b-row>
              <b-col cols="3" class="pl-0"><span>AT antes term.obra</span> </b-col>
              <b-col cols="3" class="pl-0"><span>Doc.compl.term.</span> </b-col>
              <b-col cols="3" class="pl-0"><span>PO</span> </b-col>
              <b-col cols="3" class="pl-0"><span>FAT.%</span> </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="2" class="pr-0"><b-input :disabled="!editFormEnabled" v-model="formCheckList.tipoBonificacao"></b-input></b-col>
          <b-col cols="2" class="pr-0" v-if="editFormEnabled"><b-input type="number" v-model="formCheckList.valor"></b-input></b-col>
          <b-col cols="2" class="pr-0" v-else><b-input type="text" disabled v-model="formCheckList.valorFormatado" class="text-right"></b-input></b-col>
          <b-col cols="2"><b-input disabled v-model="formCheckList.responsavelCheckList"></b-input></b-col>
          <b-col cols="1"></b-col>
          <b-col cols="5">
            <b-row>
              <b-col cols="3" class="pl-0"><b-form-select :disabled="!editFormEnabled" v-model="formCheckList.checkAtAntesTermObra" :options="[{value:null, text:'Selecione'}, 'OK ', 'NOK']" /></b-col>
              <b-col cols="3" class="pl-0"><b-form-select :disabled="!editFormEnabled" v-model="formCheckList.checkDocComplTerm" :options="[{value:null, text:'Selecione'}, 'OK ', 'NOK']" /></b-col>
              <b-col cols="3" class="pl-0"><b-form-select :disabled="!editFormEnabled" v-model="formCheckList.checkPo" :options="[{value:null, text:'Selecione'}, 'OK ', 'NOK']" /></b-col>
              <b-col cols="3" class="pl-0"><b-form-input :disabled="!editFormEnabled" type="number" v-model="formCheckList.percFat" /></b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="formularioAvaliacaoTitulo">
          <b-col cols="12"><span>Observação</span></b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="12">
            <b-textarea :disabled="!editFormEnabled" v-model="formCheckList.observacao" :max-rows="20"></b-textarea>
          </b-col>
        </b-row>
        <div v-show="!editFormEnabled">
          <ag-grid-vue style="width:100%"
                      id="obras-grid"
                      class="ag-theme-alpine mt-3"
                      domLayout='autoHeight'
                      :rowMultiSelectWithClick="false"
                      :getLocaleText="localeTextFunc"
                      :gridOptions="membersGridOptions"
                      :columnTypes="columnTypes"
                      :columnDefs="membersColumnDefs"
                      :defaultColDef="defaultColumnDef"
                      :rowData="formCheckList.membros"
                      :headerHeight="30"
                      :rowHeight="30"
                      :suppressContextMenu='true'
                      @firstDataRendered="onGridReady">
          </ag-grid-vue>
        </div>
        <div v-show="editFormEnabled">
          <ag-grid-vue style="width:100%"
                      id="obras-grid-edit"
                      class="ag-theme-alpine mt-3"
                      domLayout='autoHeight'
                      :rowMultiSelectWithClick="false"
                      :getLocaleText="localeTextFunc"
                      :gridOptions="editMembersGridOptions"
                      :columnTypes="columnTypes"
                      :columnDefs="editMembersColumnDefs"
                      :defaultColDef="defaultColumnDef"
                      :rowData="formCheckList.membros"
                      :headerHeight="30"
                      :rowHeight="30"
                      :suppressContextMenu='true'
                      @firstDataRendered="onEditGridReady">
          </ag-grid-vue>
        </div>
        <div v-if="!editFormEnabled" id="div-buttons" class="mt-4">
          <button type="button" class="btn btn-third btn-sm" :disabled="revised" v-on:click="editForm" v-b-tooltip.hover><i class="fa fa-edit"></i> Corrigir</button>
          <button type="button" class="btn btn-third btn-sm" :disabled="revised" v-on:click="approveForm" v-b-tooltip.hover><i class="fa fa-check"></i> Revisado</button>
        </div>
        <div v-if="editFormEnabled" id="div-buttons" class="mt-4">
          <button type="button" class="btn btn-third btn-sm" :disabled="revised" v-on:click="saveEditForm" v-b-tooltip.hover><i class="fa fa-check"></i> Confirmar Edição</button>
        </div>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import PdrFinalAnalysis from './pdrfinalanalysis.js'
export default PdrFinalAnalysis
</script>

<style scoped>
  * >>> .ag-header-cell {
    background-color: #008144;
    font-size: 1rem;
  }
  #div-buttons {
    margin-top: 20px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/pdrfinalanalysis/pdrfinalanalysis.vue